import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { timeout, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

// Got this from https://github.com/angular/angular/issues/28468
// which lead to https://stackblitz.com/edit/angular-abvqhq?file=src%2Fapp%2Fapp.component.ts 
// Not sure it's working right now ... need to follow up when I have time.

@Injectable()
export class OperatorInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler) {
    console.log('req in interceptor', req);
    return next.handle(req).pipe(
      timeout(10),
      catchError(e => {
      console.log('err in interceptor', e);
      return throwError(e);
    })); 
  }
}

export const OperatorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: OperatorInterceptor,
  multi: true
};